export class StorageBase{

  static getItem(p_key){
    return window[this._storage_type].getItem(p_key);
  }

  static getItemAsJSON(p_key){
    return JSON.parse(this.getItem(p_key)) ?? {};
  }

  static setItem(p_key, p_value){

    if(Array.isArray(p_value) || typeof p_value === 'object')
      p_value = JSON.stringify(p_value);

    window[this._storage_type].setItem(p_key, p_value);
    return this;
  }
}


export class LocalStorage extends StorageBase{

  static constructor(){
    this._storage_type = 'localStorage';
    return this;
  }
}


export class SessionStorage extends StorageBase{

  static constructor(){
    this._storage_type = 'sessionStorage';
    return this;
  }

  static filter_site_id_list(selected_site_id_list, column_name, column_value){
    return g_aq.from(this.getItemAsJSON('site_list'))
      .filter(g_aq.escape(d => d[column_name] == column_value && selected_site_id_list.includes(d.site_id)))
      .array('site_id')
  }
}

